import { ElectricBillUploadFileFeatures } from 'features';
import React from 'react';

const ElectricBillUploadFilePage = () => {
  return <ElectricBillUploadFileFeatures />;
};

export default ElectricBillUploadFilePage;
